import { render, staticRenderFns } from "./ProfileButton.vue?vue&type=template&id=0c6240f0&scoped=true&"
import script from "./ProfileButton.vue?vue&type=script&lang=js&"
export * from "./ProfileButton.vue?vue&type=script&lang=js&"
import style0 from "./ProfileButton.vue?vue&type=style&index=0&id=0c6240f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6240f0",
  null
  
)

export default component.exports